/* eslint-disable max-lines */
const dateFormat = 'MMM DD, YYYY';
const dateFormatWithTime = 'MMM DD, YYYY HH:mm:ss';
const dateAndTimeFormat = 'MMM DD, YYYY h:mm a';
const ddmmyyyy = 'DD/MM/YYYY';
const ddmmmmyyyy = 'DD MMMM YYYY';
const yyyymmdd = 'YYYY-MM-DD';
const yyyymmddhhmmss = 'YYYY-MM-DD HH:mm:ss';
const XlsType = 'application/vnd.ms-excel';
const XlsWpsType = 'application/wps-office.xls';
const XlsxType = 'application/wps-office.xlsx';
const OtherXlsx =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const CsvType = 'text/csv';
const JsonType = 'application/json';
const JsType = 'text/javascript';
const pythonDjangoType = 'text/x-python';
const DmnType = 'dmn';
const dateFormatWithHyphen = 'YYYY-MM-DD';
const dateFormatWithHyphenAndTime = 'YYYY-MM-DD HH:mm:ss';
const success = 'success';
const error = 'error';
const info = 'info';
const warning = 'warning';
const DMYFormatWithHyphen = 'DD-MM-YYYY';
const monthFormat = 'MMMM';
const mmmYYYY = 'MMM, YYYY';
const mmmDYYYY = 'MMM D, YYYY';
const mmmDDYYYY = 'MMM DD, YYYY';
const dMMMYYYY = 'D MMM YYYY';
const dataSourceUploadFileSizeMaxLimit = '500 Mb';
const percentageRanges = ['0-10%', '10-20%', '20-30%', '30-40%', 'Above 40%'];
const inProgress = 'IN_PROGRESS';
const completed = 'COMPLETED';
const notStarted = 'NOT_STARTED';
const masterFiles = 'master_files';
const inputFiles = 'input_files';
const totalUsers = 'total_users';
const addedUsers = 'added_users';
const removedUsers = 'removed_users';
const taskData = 'taskData';
const frequencyId = 'frequencyId';
const workflowId = 'workflowId';
const uploadFileInvoiceReviewerUserTask =
  'uploadFileINVOICE_REVIEWER_USER_TASK';
const points = 'points';
const rulePlanApproval = 'rule_plan_approval';
const grid = 'grid';
const payout = 'payout';
const invoice = 'invoice';
const query = 'query';
const rule = 'rule';
const workflowName = 'workflow_name';
const workflowUniqueId = 'workflow_unique_id';
const frequencyName = 'frequency_name';
const input = 'input';
const output = 'output';
const Accepted = 'ACCEPTED';
const Rejected = 'REJECTED';
const newGrid = 'New Grid';
const oldGrid = 'Old Grid';
const rulePlan = 'rule_plan';
const contestTask = 'contest_task';
const systemApproved = 'SYSTEM_APPROVED';
const pending = 'PENDING';
const rulePlanName = 'Rule Plan Name';
const ContestName = 'Contest Name';
const RuleName = 'Rule Name';
const ruleplanname = 'rule_plan_name';
const contestname = 'contest_name';
const rulename = 'rule_name';
const external = 'external';
const cashPoints = 'cash_points';
const startDate = 'start_date';
const endDate = 'end_date';
const frequency = 'frequency';
const accepted = 'ACCEPTED';
const open = 'OPEN';
const PdfType = 'application/pdf';
const PngType = 'image/png';
const JpegType = 'image/jpeg';
const adjustmentFileSizeMaxLimit = '5 Mb';
const dataCorrectionSummarized = 'data_correction_summarized';
const recalculationupload = ['.xlsx', '.xls'];
const cash = 'cash';
const create = 'Create';
const show = 'Show';
const edit = 'Edit';

const payoutPending = 'pending';
const payoutDone = 'done';
const filterColumnCount = 4;
const filterColumnCountDefault = 3;
const filterColumnWIdth = 100;
const frequencyTypes = {
  day: 'day',
  week: 'week',
  month: 'month',
  quarter: 'quarter',
  year: 'year',
};
const queries = 'queries';
const payouts = 'payouts';
const minimize = 'minimize';
const number = 'number';
const positive = 'positive';
const negative = 'negative';
const increased = 'increased';
const decreased = 'decreased';
const unchanged = 'unchanged';
const up = 'Up';
const down = 'Down';
const dropped = 'dropped';
const goal = 'goal';
const periodPerformance = 'Period Performance';
const earning = 'Earning';
const growing = 'Growing';
const declining = 'Declining';
const improving = 'Improving';
const reduced = 'reduced';
const score = 'Score';
const Payout = 'Payout';
const Points = 'Points';
const elite = 'elite';
const inactive = 'inactive';
const exceptionTemplate = 'exceptional approval-incentive target not achieved';
const notAvailable = 'NA';
const unificationStarted = 'unification_started';
const inReview = 'IN_REVIEW';
const approved = 'APPROVED';
const sendForRecalulcation = 'SENT_FOR_RECALCULATION';
const closed = 'CLOSED';
const recalcPeriodFormat = 'MMM-YYYY';
const recalcUploadedFormat = 'DD MMM YYYY, hh:mm A';
const recalcLabelSeparator = ' | ';
const recalcFailed = 'failed';
const range = 'range';
const slab = 'slab';
const recalcCompleted = 'recalculation_completed';

const constants = {
  dateFormat,
  dateFormatWithTime,
  ddmmyyyy,
  ddmmmmyyyy,
  yyyymmdd,
  XlsType,
  XlsWpsType,
  XlsxType,
  OtherXlsx,
  CsvType,
  JsonType,
  JsType,
  pythonDjangoType,
  DmnType,
  dateFormatWithHyphen,
  dateFormatWithHyphenAndTime,
  success,
  error,
  info,
  warning,
  DMYFormatWithHyphen,
  dateAndTimeFormat,
  monthFormat,
  mmmYYYY,
  mmmDYYYY,
  mmmDDYYYY,
  dMMMYYYY,
  yyyymmddhhmmss,
  dataSourceUploadFileSizeMaxLimit,
  percentageRanges,
  inProgress,
  completed,
  notStarted,
  masterFiles,
  inputFiles,
  totalUsers,
  addedUsers,
  removedUsers,
  taskData,
  frequencyId,
  workflowId,
  uploadFileInvoiceReviewerUserTask,
  points,
  rulePlanApproval,
  grid,
  payout,
  invoice,
  query,
  rule,
  workflowName,
  workflowUniqueId,
  frequencyName,
  input,
  output,
  Accepted,
  newGrid,
  oldGrid,
  Rejected,
  rulePlan,
  contestTask,
  systemApproved,
  pending,
  rulePlanName,
  ContestName,
  RuleName,
  ruleplanname,
  contestname,
  rulename,
  external,
  cashPoints,
  startDate,
  endDate,
  frequency,
  accepted,
  open,
  PdfType,
  PngType,
  JpegType,
  adjustmentFileSizeMaxLimit,
  dataCorrectionSummarized,
  recalculationupload,
  cash,
  create,
  show,
  edit,
  payoutPending,
  payoutDone,
  filterColumnCount,
  filterColumnCountDefault,
  filterColumnWIdth,
  frequencyTypes,
  queries,
  payouts,
  minimize,
  number,
  positive,
  negative,
  increased,
  decreased,
  unchanged,
  up,
  down,
  dropped,
  goal,
  periodPerformance,
  earning,
  growing,
  declining,
  improving,
  reduced,
  score,
  Payout,
  Points,
  elite,
  inactive,
  exceptionTemplate,
  notAvailable,
  unificationStarted,
  inReview,
  approved,
  sendForRecalulcation,
  closed,
  recalcPeriodFormat,
  recalcUploadedFormat,
  recalcLabelSeparator,
  recalcFailed,
  range,
  slab,
  recalcCompleted,
};

export default constants;
